import Vue from "vue";
import Router from "vue-router";
import Login from "../pages/login";
import Notpage from "../pages/notpage.vue";
import Home from "../pages/home.vue";
import Title from "../pages/title.vue";
import rtc from "../pages/rtc.vue";
import h5 from "../pages/h5.vue";
import pc from "../pages/pc.vue";
import client from "../pages/client.vue";
import OrderContractDetail from "../pages/orderContractDetail.vue";
import ContractDetail from "../pages/contractDetail.vue";
import ContractApprovalList from "../pages/contractApprovalList.vue";
// P44：市场端 / 财务端（按角色分流的独立 H5 端）
import MarketHome from "../pages/market/index.vue";
import FinanceHome from "../pages/finance/index.vue";
// P93：运营端（app/operation 独立后端应用；5 Tab + 消息中心 + 完成服务闭环）
import OperationHome from "../pages/operation/index.vue";
// P420：运营端独立登录页（不经过 client，可直接分享 #/operation/login）
import OperationLogin from "../pages/operation/login.vue";

Vue.use(Router);

const routes =  [
	{
		path: "/login",
		name: "Login",
		component: Login,
		hidden: true,
	},

	{
		path: "/rtc",
		name: "rtc",
		component: rtc,
		hidden: true,
	},

	{
		path: "/h5",
		name: "h5",
		component: h5,
		hidden: true,
	},
	{
		path: "/pc",
		name: "pc",
		component: pc,
		hidden: true,
	},
	{
		path: "/client",
		name: "client",
		component: client,
		hidden: true,
	},
	

	{
		path: "/home/enterprise",
		hidden: true,
		component: () => import('../pages/enterprise.vue'),
	}, 
    {
      path: "/",
      component: Home,
      name: "Home",
      leaf: true,
      iconCls: 'iconfont icon-shouye',
      children: [{
        path: '/home',
        component: Title,
        name: '首页',
        iconCls: 'iconfont icon-tanhao'
      }]
    },

    {
      path: "*",
      redirect: {
        path: '/404'
      },
      hidden: true,
    },
    {
      path: "/404",
      name: "错误页面",
      component: Notpage,
      hidden: true,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      hidden: true,
    },
	{
		path: "/rtc",
		name: "rtc",
		component: rtc,
		hidden: true,
	},
	{
		path: "/h5",
		name: "h5",
		component: h5,
		hidden: true,
	},
	{
		path: "/pc",
		name: "pc",
		component: pc,
		hidden: true,
	},
	{
		path: "/client",
		name: "client",
		component: client,
		hidden: true,
	},
	
		
]

var isLogined = localStorage.access_token ? true : false;
var initRoutes = [];
if(isLogined){
	
		
	const routesBase =  
		 [
			{
				path: "/login",
				name: "Login",
				component: Login,
				hidden: true,
			},
			{
				path: "/rtc",
				name: "rtc",
				component: rtc,
				hidden: true,
			},

			{
				path: "/h5",
				name: "h5",
				component: h5,
				hidden: true,
			},

			{
				path: "/pc",
				name: "pc",
				component: pc,
				hidden: true,
			},

			{
			path: "/client",
			name: "client",
			component: client,
			hidden: true,
		},
		{
			path: "/orderContractDetail/:sn",
			name: "OrderContractDetail",
			component: OrderContractDetail,
			hidden: true,
		},
		{
			path: "/contractDetail/:sn",
			name: "ContractDetail",
			component: ContractDetail,
			hidden: true,
		},
		{
			path: "/contractApproval",
			name: "ContractApprovalList",
			component: ContractApprovalList,
			hidden: true,
		},
		
		{
			path: "/home/enterprise",
				hidden: true,
				component: () => import('../pages/enterprise.vue'),
			}, 
			{
			  path: "/",
			  component: Home,
			  name: "Home",
			  leaf: true,
			  iconCls: 'iconfont .icon-shouye',
			  children: [{
				path: '/home',
				component: Title,
				name: '首页',
				iconCls: 'iconfont .icon-shouye'
			  }]
			},
			{
			  path: "*",
			  redirect: {
				path: '/404'
			  },
			  hidden: true,
			},
			{
			  path: "/404",
			  name: "错误页面",
			  component: Notpage,
			  hidden: true,
			}
			
	]

	if(localStorage.getItem("menuData")){
	
	
			let menuData=JSON.parse(localStorage.getItem("menuData"));
			let z=0;
			for(let i in menuData){
				if(menuData[i]["hidden"]==1){
					menuData[i]["hidden"]=true;
				}else{
					menuData[i]["hidden"]=false;
				}
				let menuArray={
					path: menuData[i]["path"],
					name: menuData[i]["label"],
                    num: menuData[i]["num"],
					api: menuData[i]["api"],
					component: Home,
					iconCls: menuData[i]["icon"],
					hidden:menuData[i]["hidden"],
					children:[],
				}
				let children=menuData[i]["children"];
				for(let j in children){
					z=z+1;
					children[j]["key"]=z;
					let url=children[j]["path"];
					console.log(z,url);
					if(children[j]["engine"]){
					  url=children[j]["engine"]+children[j]["key"]+"/info";
					}
					let menuRow={
					  name: children[j]["label"],
					  path: children[j]["path"],
					  num: children[j]["num"],
					  api: children[j]["api"],
					  component: () => import('../pages'+url+'List.vue'),
					}
					menuArray.children.push(menuRow);
					let config_hidden_page=children[j]["config_hidden_page"];
					for(let e in config_hidden_page){

					  if(config_hidden_page[e].id==1){
						let menuRow={
						  name: config_hidden_page[e]["name"],
						  path: config_hidden_page[e]["path"],
						  hidden: true,
						  component: () => import('../pages'+url+'Detail.vue'),
						}
						//console.log('../pages'+url+'Detail.vue');
						menuArray.children.push(menuRow);
					  }

					  if(config_hidden_page[e].id==2){
						let menuRow={
						  name: config_hidden_page[e]["name"],
						  path: config_hidden_page[e]["path"],
						  hidden: true,
						  component: () => import('../pages'+children[j]["path"]+'Edit.vue'),
						}
						menuArray.children.push(menuRow);
					  }


					  if(config_hidden_page[e].id==3){
						let menuRow={
						  name: config_hidden_page[e]["name"],
						  path: config_hidden_page[e]["path"],
						  hidden: true,
						  component: () => import('../pages'+children[j]["path"]+'Edit.vue'),
						}
						menuArray.children.push(menuRow);
					  }

					}

				}
				routesBase.push(menuArray);
			}
	}
	initRoutes = routesBase;
	
}else{

	initRoutes = [
		 {
		   path: "/",
		   component: Home,
		   name: "Home",
		   leaf: true,
		   iconCls: 'iconfont icon-home',
		   children: [{
			 path: '/home',
			 component: Title,
			 name: '首页',
			 iconCls: 'iconfont icon-home'
		   }]
		 },    
		 {
			path: "/home/enterprise",
			hidden: true,
			component: () => import('../pages/enterprise.vue'),
		  }, 
		  {
			path: "/account/editPassword",
			hidden: true,
			component: () => import('../pages/account/editPassword.vue'),
		  }, 
		 {
		   path: "*",
		   redirect: {
			 path: '/404'
		   },
		   hidden: true,
		 },
		 {
		   path: "/404",
		   name: "错误页面",
		   component: Notpage,
		   hidden: true,
		 },
		 {
		   path: "/login",
		   name: "Login",
		   component: Login,
		   hidden: true,
		 },
		 {
			path: "/rtc",
			name: "rtc",
			component: rtc,
			hidden: true,
		},
		{
			path: "/h5",
			name: "h5",
			component: h5,
			hidden: true,
		},
		{
			path: "/pc",
			name: "pc",
			component: pc,
			hidden: true,
		},
		{
			path: "/client",
			name: "client",
			component: client,
			hidden: true,
		},
		{
			path: "/orderContractDetail/:sn",
			name: "OrderContractDetail",
			component: OrderContractDetail,
			hidden: true,
		},
		{
			path: "/contractDetail/:sn",
			name: "ContractDetail",
			component: ContractDetail,
			hidden: true,
		},
		
		
	]
}
// P44：市场端 / 财务端路由 —— 上面三个分支（routes / routesBase / 未登录兜底）都会汇总到
// initRoutes，故在定稿后统一注入，避免三处重复维护。二者均为「按角色分流」的独立 H5 端，
// 未登录时不应出现在菜单里（hidden）。
;[
  { path: '/market', name: 'MarketHome', component: MarketHome, hidden: true },
  { path: '/finance', name: 'FinanceHome', component: FinanceHome, hidden: true },
  /* 【P420】运营端独立登录页必须排在 /operation 之前注入，且在路由守卫白名单里放行。
     它是运营端唯一的登录入口：未登录访问 #/operation 会被 operation/index.vue
     重定向到这里；退出登录也回这里（LOGIN_HOME.operation）。 */
  { path: '/operation/login', name: 'OperationLogin', component: OperationLogin, hidden: true },
  { path: '/operation', name: 'OperationHome', component: OperationHome, hidden: true }
].forEach(function (r) {
  if (!initRoutes.some(function (x) { return x.path === r.path })) {
    initRoutes.push(r)
  }
})

// hash //history
const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes: initRoutes
});

// 路由守卫
router.beforeEach((to, from, next) => {
  const isLogin = localStorage.access_token ? true : false;
  if (to.path == '/login' || to.path == '/rtc' || to.path == '/h5' || to.path == '/client'
      || to.path == '/market' || to.path == '/finance' || to.path == '/operation'
      /* 【P420】运营端独立登录页：未登录时必须能打开，否则退出后会卡在「要登录但进不去登录页」 */
      || to.path == '/operation/login') {
    next();
  } else {
    // 是否在登录状态下
    isLogin ? next() : next('/login');
  }
});

router.routes = initRoutes;
export default router;





// WEBPACK FOOTER //
// ./src/router/index.js